import { render, staticRenderFns } from "./ArtworkFilter.vue?vue&type=template&id=0b0b4c9c&scoped=true"
import script from "./ArtworkFilter.vue?vue&type=script&lang=js"
export * from "./ArtworkFilter.vue?vue&type=script&lang=js"
import style0 from "./ArtworkFilter.vue?vue&type=style&index=0&id=0b0b4c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b4c9c",
  null
  
)

export default component.exports